<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Hardware</a></li>
          <li><a>Sensors</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home" alt="Home icon"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Sensors</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by sensor, code, qp, type etc.."/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let sensor of sensorsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ sensor && sensor.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Vendor name:</span>
                  <span class="text">{{sensor && sensor.vendor_name}}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Quality Parameter:</span>
                  <span class="text">{{sensor && sensor.qp.name}}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Sensor Type:</span>
                  <span class="text">{{sensor && sensor.sensorType.name}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ sensor?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Business Type" (click)="getSensorById(sensor.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Sensor Not Found</div>
        <!--sensor types block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Sensors</div>
                <button class="add-update-submit-button" (click)="addUpdateSensor()" [disabled]="sensorDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Enter name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                    <i> {{f.name.hasError('required') ? 'Sensor name is required.': f.name.hasError('minlength')? 'Minimum 3 characters required.': f.name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : f.name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <!--  Name -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="vendorName" type="text" formControlName="vendor_name" autocomplete="off" placeholder="Enter vendor name"/>
                  <!-- Hint -->
                  <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                  <!-- Single dynamic error -->
                  <mat-error *ngIf="(f.vendor_name.dirty || f.vendor_name.touched || submitted) && f.vendor_name.errors">
                    <i> {{f.vendor_name.hasError('required') ? 'Vendor name is required.': f.vendor_name.hasError('minlength')? 'Minimum 3 characters required.': f.vendor_name.hasError('maxlength')
                      ? 'Maximum 20 characters allowed.' : f.vendor_name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Quality Parameter</mat-label>
                  <mat-select id="sitename" formControlName="qp_id">
                    <mat-option value="" disabled>Select Quality Parameter</mat-option>
                    <mat-option *ngFor="let category of queryParams" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.qp_id.invalid"><i>Select Quality Parameter</i></mat-hint>
                  <mat-hint *ngIf="f.qp_id.valid"><i>Quality Parameter selected</i></mat-hint>
                  <mat-error *ngIf="(f.qp_id.touched || f.qp_id.dirty || submitted) && f.qp_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Sensor Type</mat-label>
                  <mat-select id="sensortype" formControlName="sensor_type_id">
                    <mat-option value="" disabled>Select Sensor Type</mat-option>
                    <mat-option *ngFor="let category of sensorTypes" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.sensor_type_id.invalid"><i>Select Sensor Type</i></mat-hint>
                  <mat-hint *ngIf="f.sensor_type_id.valid"><i>Sensor Type selected</i></mat-hint>
                  <mat-error *ngIf="(f.sensor_type_id.touched || f.sensor_type_id.dirty || submitted) && f.sensor_type_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
